import { EVENT_PLATFORMS } from '@pw-tech/web-sdk'
import { EventType } from '../events'
import { getGlobalProperties } from '../globalProperties'

export const logAmbassadorEvent = (
  eventName: EventType,
  eventData: Record<string, unknown> = {}
) => {
  const payload = {
    ...getGlobalProperties(),
    ...eventData,
  }
  window?.PWWebSDK?.eventService?.logEvent({
    eventName,
    eventData: payload,
  })
}

export default logAmbassadorEvent